const settings = {
  dashboardSettings: {},
  newDealNotificationRecipients: [],
  approvedDealNotificationRecipients: [],
  rejectedDealNotificationRecipients: [],
  carbonCopyDealNotificationRecipients: [],
  headCountSettings: {},
  payRateSettings: {},
  revenueYTD: null,
  zohoIntegrationSettings: {},
  beginningOfWeek: null,
  scheduledJobsSettings: {
    assignmentsAboutToEnd: {
      isActive: false
    },
    timeSheetNoTimeEnteredNotification: {
      isActive: false
    },
    timeSheetNoTimeEnteredReminder: {
      isActive: false
    }
  },
  emailSettings: {}
}

export default () => Object.assign({}, settings)
